module.exports = __webpack_public_path__ + "img/about-values-header.jpg?a815007d99e78f026a9e9a2f0b0db3ea";